export const saveInstitutionCard = [
  '',
  `mutation saveInstitutionCard ($input: InputInstitutionCard!) {
    saveInstitutionCard (input: $input)
  }`,
  'saveInstitutionCard',
];
